// extracted by mini-css-extract-plugin
export default {"Page":"Address_Page__nbxdl","AddButton":"Address_AddButton__yxK4J","List":"Address_List__nkxKD","Loader":"Address_Loader__pKpEn"};